module.exports = __webpack_public_path__ + "static/media/Noto1.07d3fa70.webp";